import type { FaireProductEntity } from "../../entity_types/product";

export const p_9jcy7tkfgd: FaireProductEntity = {
  token: "p_9jcy7tkfgd",
  type: "product",
  name: "International Exotic Snack Box – 15 Foreign Snacks",
  brandToken: "b_2xjdvub937",
  brandName: "Ceres Gourmet",
  imageUrl:
    "https://cdn.faire.com/fastly/ed9bf373e4a1d9f0db829fdfc5b7d9b6c9691edd30c8e381b3151e6667769167.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/749d289049d0a7c7ffb23fb0b9fa04f12c2b377b68fc058aac0178df8f8040c6.jpeg",
    "https://cdn.faire.com/fastly/ac46af170bc7b1add2498c139a591f1395f1cdcbf8b6cb16112e402aeb6c3b38.jpeg",
    "https://cdn.faire.com/fastly/b7ce0a9e27d928d09bd8c2f7486747036e29750f20a9d8ccf9852ebbceaccfad.jpeg",
    "https://cdn.faire.com/fastly/810d83da7d9ca9baad0e504eca56061a9c60a5ec93bedb5785e4c057e97e12d9.jpeg",
    "https://cdn.faire.com/fastly/bb97c4cd08183d0e126733313f611e35a34ca542b7c7da2898421e7b83f925a3.jpeg",
    "https://cdn.faire.com/fastly/4d0bc423721874aedc32e68d49dd9f0501e1ffc0283e0696413403906fa0555b.jpeg",
    "https://cdn.faire.com/fastly/c1b633bdd22fb54e18bf1b37c8c57c47c945281749463e20c1c0a16397828718.jpeg",
  ],
  priceDollars: 16.53,
  description:
    "International Exotic Treats Box – 15 Premium Foreign Rare Snacks\n\n*Product Description:\nExperience global flavors with the International Exotic Treats Box. This collection includes 15 mini snacks, offering a mix of sweet, savory, crunchy, and chewy treats. Each snack is individually wrapped for freshness and convenience.\n\n*Key Features:\n15 Assorted Snacks: Crackers, wafers, candies, chocolates, and mystery treats.\nPerfect for Gifting: Great for birthdays, holidays, or special occasions.\nFun for Everyone: Ideal for family, friends, or coworkers who enjoy variety.\nFresh and Convenient: Individually wrapped for easy sharing or solo indulgence.\n\n*What’s Inside the Box:\n2 Crunchy Crackers \n2 Wafers or Biscuits\n6 Candies or Gum \n2 Chocolates\n3 Extra Mystery Treats\n*Experience:\nThe International Exotic Treats Box is more than just a snack—it’s a cultural journey in every bite.\n\n*Please note that depending on the production batch, 1–2 items inside the box may vary.",
  tags: [],
  msrpDollars: 33.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:02.288Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
